import { useState } from 'react'
import { Monitor, Moon, Sun } from '@/lib/icons'
import type { IconType } from '@/lib/icons'
import type { ThemePref } from '@/lib/theme'
import { getThemePref, setThemePref } from '@/lib/theme'
import { cn } from '@/lib/utils'

/** Sikl tartibi: tizim → yorug' → qorong'i → tizim. */
const ORDER: readonly ThemePref[] = ['auto', 'light', 'dark']

const META: Record<ThemePref, { icon: IconType; label: string }> = {
  auto: { icon: Monitor, label: 'Tizim' },
  light: { icon: Sun, label: "Yorug'" },
  dark: { icon: Moon, label: "Qorong'i" },
}

interface ThemeToggleProps {
  /** Yig'ilgan sidebar / mobil header — faqat ikonka ko'rsatiladi. */
  collapsed?: boolean
}

/**
 * Mavzuni bir tugma orqali aylantirib almashtiradi (auto/light/dark) va tanlovni saqlaydi.
 * `lib/theme.ts` `setThemePref` `<html data-theme>` ni darhol yangilaydi, `lib/prefs.ts`
 * localStorage'ga yozadi — keyingi ochilishda `index.html` inline skripti uni tiklaydi.
 */
export function ThemeToggle({ collapsed = false }: ThemeToggleProps) {
  const [pref, setPref] = useState<ThemePref>(() => getThemePref())
  const meta = META[pref]
  const Icon = meta.icon

  const cycle = () => {
    const next = ORDER[(ORDER.indexOf(pref) + 1) % ORDER.length] ?? 'auto'
    setThemePref(next)
    setPref(next)
  }

  return (
    <button
      type="button"
      onClick={cycle}
      title={`Mavzu: ${meta.label}`}
      aria-label={`Mavzu: ${meta.label}. Almashtirish uchun bosing`}
      className={cn(
        'flex min-h-11 items-center rounded-button text-sm font-medium text-app-hint transition-colors duration-150 ease-out hover:bg-app-card hover:text-app-text',
        collapsed ? 'justify-center px-0' : 'gap-3 px-3',
      )}
    >
      <Icon size={18} aria-hidden="true" />
      {!collapsed && <span>{meta.label}</span>}
    </button>
  )
}
